<template>
  <div class="exertsDetails">
    <div class="title">
      <span>当前位置：&nbsp</span>
      <span>展会</span>
      <span>></span>
      <span>会议论坛</span>
      <span style="margin: 0 9px;">></span>
      <span @click="backEvents">论坛专家</span>
      <span style="margin: 0 9px;">></span>
      <span>论坛专家详情</span>
    </div>
    <div class="content">
      <div class="content_top">
        <p class="content_top_title">{{ title }}</p>
        <p class="content_top_content">
          <span>{{ uploadDate ? uploadDate : createDate }}</span>
          <span>
            围观
            <b>{{ watchs }}</b>次
          </span>
        </p>
      </div>
      <div class="content_center" v-html="content"></div>
      <!-- <div class="backImg">
        <img :src="$getSrc(imageSrc)" alt />
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  props: ["eventId", "informationTypeList"],
  data() {
    return {
      title: "",
      watchs: 0,
      createDate: "",
      content: "",
      imageSrc: "",
      uploadDate: ""
    };
  },
  mounted() {
    if (this.eventId) {
      this.getEventInformationDetail(this.eventId);
    }
  },
  methods: {
    // 当前资讯信息
    getEventInformationDetail(currentId) {
      this.$http({
        url: "informationInfo",
        method: "post",
        params: {
          id: currentId,
        },
      }).then(({ data }) => {
        let { code, information } = data;
        if (code === 0) {
          this.title = information.title;
          this.content = information.content;
          this.watchs = information.watchs;
          this.imageSrc = information.image;
          this.createDate = information.createDate.substring(0, 10);
          this.uploadDate = information.uploadDate ? information.uploadDate.substring(0, 10) : "";
        }
      });
    },

    backEvents() {
      this.$emit("setEventId");
    },
  },
};
</script>>
<style lang="scss" scoped>
.exertsDetails {
  min-height: 1180px;
  background-color: #ffffff;
  box-shadow: -8px 0px 8px #fafafa, 0px -8px 8px #fafafa, 0px 8px 8px #fafafa;
  margin-bottom: 45px;
  .title {
    height: 43px;
    border-bottom: 1px solid #e5e5e5;
    line-height: 43px;
    padding-left: 17px;
    color: #b6b6b6;
    font-size: 12px;
    span:nth-child(3),
    span:nth-child(5) {
      margin: 0 11px;
    }
    span:nth-child(6) {
      cursor: pointer;
    }
  }
  .content {
    width: 857px;
    min-height: 892px;
    margin: 50px auto 63px;
    .content_top {
      height: 83px;
      border-bottom: 1px solid #dfe1e1;
      position: relative;
      .content_top_title {
        padding: 0 24px 0 10px;
        line-height: 45px;
        font-size: 28px;
        text-align: center;
      }
      .content_top_content {
        width: 200px;
        position: absolute;
        text-align: right;
        font-size: 12px;
        color: #bbbbbb;
        right: 0;
        bottom: 5px;
        span:first-child {
          margin-right: 23px;
        }
        // margin-top: -23px;
      }
    }
    .content_center {
      min-height: 445px;
      overflow: hidden;
      margin-top: 50px;
    }
    .backImg {
      width: 531px;
      height: 320px;
      margin: 50px auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>